export default "__VITE_ASSET__57a71e5f__"